module.exports = __webpack_public_path__ + "static/media/feedback-icon.ea58ea97.svg";